import { ThunkAction, ThunkDispatch } from 'redux-thunk';

import * as Model from '../models';
import { storageState } from '../service/storage-service';

import { LOAD_PROJECTS } from './project-actions';

export const LOAD_WORLD_ITEM = 'LOAD_WORLD_ITEM';

export type ProjectsLoadActionPayload = Model.ProjectItem[];

export type ProjectsLoadReduxAction = Model.ReduxAction<ProjectsLoadActionPayload>;

export type WorldItemLoadActionPayload = Model.WorldItem;

export type WorldItemLoadReduxAction = Model.ReduxAction<WorldItemLoadActionPayload>;

export type RootDataLoadFnRequest = {
  countryCode: string;
  langCode: string;
  customerType: string;
  sessionToken?: string;
};

export type RootDataLoadFn = ((request: RootDataLoadFnRequest) => ThunkAction<ng.IPromise<Model.RootState>, Model.RootState, object, ProjectsLoadReduxAction | WorldItemLoadReduxAction>);

export type RootDataLoadDispatch = ThunkDispatch<Model.RootState, object, ProjectsLoadReduxAction | WorldItemLoadReduxAction>;

export type RootDataLoadAction = {
  loadStorageData: RootDataLoadFn;
};

export type RootDataLoad = (request: RootDataLoadFnRequest) => ng.IPromise<Model.RootState>;

export type RootDataLoadSupport = {
  loadStorageData: RootDataLoad | null;
};

export type RootActions = RootDataLoadAction;

export type RootActionsService = ($q: ng.IQService) => RootActions;
export const ROOT_ACTIONS_SERVICE_NAME = 'RootActionsService';
export const RootActionsService: RootActionsService = ($q: ng.IQService): RootActions => {
  return {
    loadStorageData: (request: RootDataLoadFnRequest) => {
      return (dispatch: RootDataLoadDispatch,
              getState: () => Model.RootState,
              extraArgs: object) => {
        const deferred: ng.IDeferred<Model.RootState> = $q.defer();
        const { countryCode, langCode: language, customerType, sessionToken } = request;
        const defaultState: Model.RootState = {
          projects: [],
          world: {
            ...Model.WORLD_INITIAL,
            countryCode,
            language,
            customerType,
            sessionToken,
          },
        };
        storageState($q, {
          key: Model.STORAGE_KEY_PRFIX,
          type: Model.STORAGE_TYPE,
          defaultResponse: defaultState,
        }).then((rootState: Model.RootState) => {
          dispatch({ type: LOAD_PROJECTS, payload: rootState.projects });
          dispatch({ type: LOAD_WORLD_ITEM, payload: rootState.world });
          deferred.resolve(rootState);
        });
        return deferred.promise;
      };
    },
  };
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/actions/root-actions.ts